import axios from '@/utils/request'
var Qs = require('qs')
export default {

	//     // 2020-09-21
	//     insertBatch(params) {
	//         return axios.post('/weddingDressHall/payment/insert-batch', params)
	//     },
	// 2021-10-06
	create(params) {
		return axios.post('/weddingDressHall/payment', params)
	},
	// 2021-10-14
	update(id, params) {
		return axios.put('/weddingDressHall/payment/' + id, params)
	},
	// 2021-10-14
	delete(id) {
		return axios.delete('/weddingDressHall/payment/' + id)
	},

	//     // 2020-12-08 账单
	//     findBySettlementId(settlementId) {
	//         return axios.get('/weddingDressHall/payment/find-by-settlement-id/' + settlementId)
	//     },
	//     // 2020-12-08 账单
	//     confirm(id) {
	//         return axios.put('/weddingDressHall/payment/' + id + '/confirm')
	//     },
	//     // 2020-12-08 账单
	//     createAndConfirm(params) {
	//         return axios.post('/weddingDressHall/payment/create-and-confirm', params)
	//     },

	//     // 2021-02-24 工作台
	//     diffAmountReportForWorkBench(params) {
	//         return axios.get('/weddingDressHall/payment/diff-amount-report-for-work-bench?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	//     },

	//     // 2021-03-08
	//     detailReport(params) {
	//         return axios.get('/weddingDressHall/payment/detail-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	//     },
	//     // 2021-03-08
	//     detailReportTotal(params) {
	//         return axios.get('/weddingDressHall/payment/detail-report-total?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	//     },
	//     // 2021-03-08
	//     detailReportExportExcel(params) {
	//         return axios.get('/weddingDressHall/payment/detail-report-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	//     },
	//     // 2021-04-24
	//     salesRevenueReportPayDetail(params) {
	//         return axios.get('/weddingDressHall/payment/sales-revenue-report-pay-detail?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	//     },
	//     // 2021-04-28
	//     salesRevenueReportPayDetailExportExcel(params) {
	//         return axios.get('/weddingDressHall/payment/sales-revenue-report-pay-detail-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	//     },
	//     // 2021-05-19
	//     unSaleSettle(params) {
	//         return axios.get('/weddingDressHall/payment/un-sale-settle?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	//     },
	//     // diffAmountReport(params) {
	//     //     return axios.get('/weddingDressHall/payment/diff-amount-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	//     // },

	//     // diffAmountTotal(params) {
	//     //     return axios.get('/weddingDressHall/payment/diff-amount-total?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	//     // }
}

